import EbookReadingPage from "./ebook-reading.page";

export default EbookReadingPage;
